import { Icon } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './EmptyState.styles';

export const EmptyState = () => {
  const { t } = useTranslation(['earnings']);

  return (
    <S.Root>
      <Icon iconName="AutomaticRefinement" size={80} viewBox="0 0 60 60" />
      <S.Title>
        {t('earnings:earningsInsight.drawer.alfredIsAnalyzing')}
      </S.Title>
      <S.Description>
        {t('earnings:earningsInsight.drawer.checkBackSoon')}
      </S.Description>
    </S.Root>
  );
};
